import { DeleteWithToken, GetWithToken, PostWithToken, PutWithToken } from "../../lib/request";

export const getAllDiscounts = (status) => {
    return async function () {
        const query = status ? `?status=${status}` : "";
        return await GetWithToken(`/v2/admin/discount${query}`);
    };
};

export const getDiscountById = (id) => {
    return async function () {
        return await GetWithToken(`/v2/admin/discount/${id}`);
    };
};

export const createDiscount = (data) => {
    return async function () {
        return await PostWithToken("/v2/admin/discount", data);
    };
};

export const updateDiscountById = (id, data) => {
    return async function () {
        return await PutWithToken(`/v2/admin/discount/${id}`, data);
    };
};

export const deleteDiscountById = (id) => {
    return async function () {
        return await DeleteWithToken(`/v2/admin/discount/${id}`);
    };
};
